import { Input } from "antd";
import { bool, object } from "prop-types";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { DynamicFormItem } from "./DynamicFormItem";
import { getPlaceholderText } from "./helper/getPlaceholderText";
import { useCheckEditableFormField } from "./hooks/useCheckEditableFormField";

export const DynamicInput = ({
  formField,
  formField: {
    property,
    property: { maxCharacterLength, name },
  },
  formDisabled,
}) => {
  const intl = useIntl();
  const { isDisabled, calculatedFields, handleValuesChange, formRef } =
    useCheckEditableFormField(formField);

  useEffect(() => {
    if (
      calculatedFields &&
      Object.keys(calculatedFields).length &&
      Object.keys(calculatedFields).includes(name) &&
      formRef.current.getFieldValue(name) !== calculatedFields[name]
    ) {
      const newTextValue = {};
      newTextValue[name] = calculatedFields[name];
      formRef.current.setFieldsValue(newTextValue);
      handleValuesChange(newTextValue);
    }
  }, [calculatedFields, formRef, handleValuesChange, name]);

  const characterLengthProps =
    maxCharacterLength > 0
      ? { maxLength: maxCharacterLength, showCount: true }
      : {};

  return (
    <DynamicFormItem formFieldProperty={property}>
      <Input
        data-test-id={`dynamic-input-${property.name}`}
        disabled={formDisabled || isDisabled}
        placeholder={getPlaceholderText(formDisabled, formField, intl)}
        {...characterLengthProps}
      />
    </DynamicFormItem>
  );
};

DynamicInput.propTypes = {
  formField: object.isRequired,
  formDisabled: bool,
};
